import { gql, QueryResult, useQuery } from '@apollo/client'
import type {
  RecommendedPageQuery,
  RecommendedPageQueryVariables,
} from 'apollo-gql'

import cardProfileProductFragment from '../graphql/fragments/cardProfileProductFragment'

type UseRecommendedReturn = {
  recommendedCollection?: RecommendedPageQuery['market']['recommendedProfileProducts']
} & Pick<
  QueryResult<RecommendedPageQuery, RecommendedPageQueryVariables>,
  'loading' | 'error'
>

export default function useRecommended({
  marketId,
  profileId,
}: RecommendedPageQueryVariables): UseRecommendedReturn {
  const { loading, data, error } = useQuery<
    RecommendedPageQuery,
    RecommendedPageQueryVariables
  >(
    gql`
      query RecommendedPage($marketId: ID!, $profileId: ID!) {
        market(id: $marketId) {
          recommendedProfileProducts(profileId: $profileId) {
            ...cardProfileProductFragment
          }
        }
      }
      ${cardProfileProductFragment}
    `,
    {
      skip: !profileId,
      variables: {
        marketId,
        profileId,
      },
    },
  )

  const recommendedCollection = data && data.market?.recommendedProfileProducts

  return { recommendedCollection, loading, error }
}
